/**
 * Rock Off Retail — back-to-top button.
 *
 * Appears once the page has scrolled past ~600px, smooth-scrolls to top on
 * click (instant jump if the visitor prefers reduced motion), and is a
 * plain <button> so it's keyboard-reachable/activatable with no extra ARIA
 * plumbing beyond the aria-label already on the element.
 */
(() => {
  const SHOW_AFTER_PX = 600;
  const button = document.getElementById('RockoffBackToTop');
  if (!button) return;

  let ticking = false;

  function update() {
    ticking = false;
    button.classList.toggle('is-visible', window.scrollY > SHOW_AFTER_PX);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  update();

  button.addEventListener('click', () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
})();
